<template>
    <BaseForm>
        <template #fields>
            <TextField
                :value="fields.nameShort"
                :label="$t('name-short')"
                :error-messages="errors.nameShort"
                :required="true"
                @input="$emit('onInput', { event: $event, fieldName: 'nameShort' })"
            />
            <TextField
                :value="fields.nameLong"
                :label="$t('name-long')"
                :error-messages="errors.nameLong"
                :required="true"
                @input="$emit('onInput', { event: $event, fieldName: 'nameLong' })"
            />
            <NumberField
                :value="fields.year ?? ''"
                :label="$t('year')"
                :error-messages="errors.year"
                :required="true"
                @input="$emit('onInput', { event: $event, fieldName: 'year' })"
            />
            <TextField
                :value="fields.intention"
                :label="$t('intention')"
                :error-messages="errors.intention"
                @input="$emit('onInput', { event: $event, fieldName: 'intention' })"
            />
            <TextAreaField
                :value="fields.description"
                :label="$t('description')"
                :error-messages="errors.description"
                @input="$emit('onInput', { event: $event, fieldName: 'description' })"
            />
        </template>
    </BaseForm>
</template>
<script setup lang="ts">
import BaseForm from '@/components/Form/BaseForm.vue';
import NumberField from '@/components/Form/NumberField.vue';
import TextAreaField from '@/components/Form/TextAreaField.vue';
import TextField from '@/components/Form/TextField.vue';
import { ScenarioErrors, ScenarioFields } from '@/scenario/types';

defineProps<{ fields: ScenarioFields; errors: ScenarioErrors }>();
defineEmits<{ (e: 'onInput', v: { event: Event; fieldName: string }): void }>();
</script>
